import { MHStack, MTag, MText } from '../../Monetize';

/** "TERM 3" eyebrow plus Current / Upcoming markers */
export const ContractTermLabel = ({
  termNumber,
  isCurrent,
  isUpcoming,
}: {
  termNumber: number;
  isCurrent: boolean;
  isUpcoming: boolean;
}) => (
  <MHStack gap={1.5} minH="20px">
    <MText
      as="span"
      fontSize="xxs"
      fontWeight="bold"
      letterSpacing="0.05em"
      textTransform="uppercase"
      color="fg.muted"
    >
      Term {termNumber}
    </MText>
    {isCurrent && <MTag variant="blue">Current</MTag>}
    {isUpcoming && <MTag variant="outline">Upcoming</MTag>}
  </MHStack>
);
